<template>
    <component
        :is="layout"
        :wayToGet="wayToGetLocal"
        :dark="dark"
    >
        <template v-if="!hideMeetingType && !unavailableOffice" #wayToGet>
            <slot name="wayToGetInput" :value="wayToGetLocal" :setValue="(val) => wayToGetLocal = val">
                <ui-image-box-switcher
                    v-model="wayToGetLocal"
                    :items="[
                        {
                            value: EWayToGet.OFFICE,
                            label: 'В офисе',
                            image: 'office',
                        },
                        {
                            value: EWayToGet.DELIVERY,
                            label: 'С доставкой',
                            image: 'delivery',
                        },
                    ]"
                />
            </slot>
        </template>
        <template v-if="wayToGetLocal === EWayToGet.DELIVERY" #region>
            <ui-form-field
                label="Выберите регион"
                :value="regionLocal"
                :errors="vuelidateErrorMesages['regionLocal']"
                class="_w-100"
                :dark="dark"
            >
                <template v-slot:default="{ errors }">
                    <ui-bank-region-picker
                        :is-error="!!errors.length"
                        searchable
                        :value-code.sync="$v.regionLocal.$model"
                        :dark="dark"
                    />
                </template>
            </ui-form-field>
        </template>
        <template v-if="isShowCity" #city>
            <ui-form-field
                label="Выберите город"
                :value="cityLocal"
                :errors="vuelidateErrorMesages['cityLocal']"
                class="_w-100"
                id="meeting-city"
                :dark="dark"
            >
                <template v-slot:default="{ errors, id }">
                    <d-select-search-stable
                        :id="id"
                        v-model="$v.cityLocal.$model"
                        :list="cities"
                        :is-error="!!errors.length"
                        :is-loading="isLoadingCities"
                        searchable
                        :disabled="isLoadingCities || cities.length === 0"
                        :single-line="false"
                        :dark="dark"
                    />
                </template>
            </ui-form-field>
        </template>
        <template v-if="wayToGetLocal === EWayToGet.DELIVERY && $slots.noCitiesDeliveryNotice" #noCitiesDeliveryNotice>
            <slot name="noCitiesDeliveryNotice"></slot>
        </template>
        <template v-if="wayToGetLocal === EWayToGet.OFFICE && $slots.noCitiesOfficeNotice" #noCitiesOfficeNotice>
            <slot name="noCitiesOfficeNotice"></slot>
        </template>
        <template v-if="isShowAddress" #address>
            <ui-form-field
                label="Адрес доставки, улица, дом/офис, кв./помещ."
                :errors="vuelidateErrorMesages['addressLocal']"
                :value="$v.addressLocal.$model"
                class="_w-100"
                id="meeting-address"
                :dark="dark"
            >
                <template v-slot:default="{ id, errors }">
                    <UiTextInputSuggestions
                        :id="id"
                        :error="!!errors.length"
                        v-model="$v.addressLocal.$model"
                        name="meeting-address"
                        :suggestionType="ESuggestionTypes.ADDRESS"
                        :locations="addressLocations"
                        :count="5"
                        :dark="dark"
                        onlySuggestion
                        @update:data="(val) => $emit('update:address-object', val)"
                    />
                </template>
            </ui-form-field>
        </template>
        <template v-if="isShowOffices" #office>
            <ui-form-field
                label="Выберите офис"
                :value="officeLocal"
                :errors="vuelidateErrorMesages['officeLocal']"
                class="_w-100"
                id="meeting-office"
                :dark="dark"
            >
                <template v-slot:default="{ errors, id }">
                    <d-select-search-stable
                        :id="id"
                        v-model="$v.officeLocal.$model"
                        :list="offices"
                        :is-error="!!errors.length"
                        :is-loading="isLoadingOffices"
                        searchable
                        :disabled="isLoadingOffices"
                        :single-line="false"
                        :dark="dark"
                    />
                </template>
            </ui-form-field>
        </template>
        <template v-if="isShowDate" #date>
            <ui-form-field
                id="meeting-date"
                label="Дата доставки"
                :value="$v.dateLocal.$model"
                :errors="vuelidateErrorMesages['dateLocal']"
                :dark="dark"
            >
                <template v-slot:default="{ id, errors, isFocused }">
                    <UiDatePicker
                        v-model="$v.dateLocal.$model"
                        :id="id"
                        :placeholder="isFocused ? 'ДД.ММ.ГГГГ' : ''"
                        :disabled-date="disabledDates"
                        :dark="dark"
                        :error="!!errors.length"
                    />
                </template>
            </ui-form-field>
        </template>
        <template #time>
            <ui-form-field
                v-if="times.length"
                label="Время"
                :value="$v.timeLocal.$model"
                :errors="vuelidateErrorMesages['timeLocal']"
                id="meeting-times"
                :dark="dark"
            >
                <template v-slot:default="{ errors, id }">
                    <d-select-search-stable
                        :id="id"
                        v-model="$v.timeLocal.$model"
                        :searchable="false"
                        :list="times"
                        :is-error="!!errors.length"
                        :is-loading="isLoadingTimes"
                        :disabled="isLoadingTimes || times.length === 0"
                        :single-line="false"
                        :dark="dark"
                    />
                </template>
            </ui-form-field>
        </template>
        <template
            v-for="(_, slot) in slotsDrill"
            v-slot:[slot]="scope"
        >
            <slot :name="slot" v-bind="scope || {}"/>
        </template>
    </component>
</template>
<script>
import UiBankRegionPicker from '../UiBankRegionPicker.vue';
import { computed, watch, ref, useSlots } from 'vue';
import { useBankCityList, ERepositoryCities } from '../../../hooks/useBankCityList';
import { useBankOfficeList } from '../../../hooks/useBankOfficeList';
import { useBankTimeslotsList, ERepositoryTimeslots } from '../../../hooks/useBankTimeslotsList';
import vuelidateMessages from '../../../assets/js/vue/validationsMessages';
import { extractVuelidateErrors } from '../../../assets/js/vue/utlis/extractVuelidateErrors';
import { required, maxLength, helpers } from 'vuelidate/lib/validators';
import { limitLatSymbol } from '../../../assets/js/vue/validations';
import { useSyncValue } from '../../../hooks/useSyncValue';
import { validationMixin } from 'vuelidate';
import { ESuggestionTypes } from '../../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes'
import UiTextInputSuggestions from '../../ui/UiTextInputSuggestions.vue';
import { getOfficesV2 } from '../../../assets/js/utils';
import { EWayToGet, EValidationStatus, EAppointmentDeliveryType } from './const';
import DefaultLayout from './DefaultLayout.vue';
import UiDatePicker from '../../../components/ui/UiDatePicker.vue';
import { requiredIf } from 'vuelidate/lib/validators';
import { useStore } from '../../../store';

export default {
    name: 'MeetingForm',
    props: {
        productCode: {
            type: String,
            required: true,
        },
        wayToGet: {
            type: String,
            default: EWayToGet.OFFICE,
        },
        region: String,
        city: String,
        office: String,
        address: String,
        date: String,
        time: String,
        layout: {
            type: Object,
            default: () => DefaultLayout,
        },
        hideMeetingType: Boolean,
        noDateTime: Boolean,
        noAddress: Boolean,
        dark: Boolean,
        filterOfficesPremium: Boolean,
        /** Показывать слоты только в городах, где есть МБ */
        mbOnly: Boolean,
    },
    emits: [
        'workDays', 'update:wayToGet', 'update:region',
        'update:city', 'update:office', 'update:address',
        'update:date', 'update:time', 'status',
        'city-title', 'delivery-type', 'unavailable-office-pending',
        'office-address', 'update:address-object',
    ],
    components: {
        UiBankRegionPicker,
        UiTextInputSuggestions,
        UiDatePicker,
    },
    mixins: [
        validationMixin,
    ],
    setup(props, { emit }) {
        const { value: wayToGetLocal } =  useSyncValue(() => props.wayToGet, (val) => emit('update:wayToGet', val));

        const store = useStore();
        let citiesError = computed(() => {
            return store.state.meeting.citiesError;
        });
        let slotsError = computed(() => {
            return store.state.meeting.slotsError;
        });

        /**
         * Встреча в офисе недоступна
         */
        const unavailableOffice = ref(false);
        const unavailableOfficePending = ref(!props.hideMeetingType);
        /**
         * Проверка на доступность доступность встречи в офисе
         * отключаем выбор встречи в офисе, если не выбран город и пустой список офисов
         */
        if (!props.hideMeetingType) {
            let data = {};
            if (props.productCode === 'escrow') data = { isEscrow: 'y' };
            getOfficesV2(undefined, data, 'name')
                .then((res) => {
                    unavailableOffice.value = !(res.data.data.length > 0);
                })
                .catch(() => {
                    unavailableOffice.value = true;
                })
                .finally(() => {
                    unavailableOfficePending.value = false;
                    if (!unavailableOffice.value) return;

                    // переключаем на доставку
                    if (!props.onlyOffice) wayToGetLocal.value = EWayToGet.DELIVERY;
                });
        }

        watch(unavailableOfficePending, (val) => {
            emit('unavailable-office-pending', val);
        }, { immediate: true });


        const { value: regionLocal } =  useSyncValue(() => props.region, (val) => emit('update:region', val));
        const { value: cityLocal } =  useSyncValue(() => props.city, (val) => emit('update:city', val));
        const { value: officeLocal } =  useSyncValue(() => props.office, (val) => emit('update:office', val));
        const { value: addressLocal } =  useSyncValue(() => props.address, (val) => emit('update:address', val));
        const { value: dateLocal } =  useSyncValue(() => props.date, (val) => emit('update:date', val));
        const { value: timeLocal } =  useSyncValue(() => props.time, (val) => emit('update:time', val));

        const repositoryCities = computed(() => wayToGetLocal.value === EWayToGet.OFFICE ? ERepositoryCities.NETWORK : ERepositoryCities.MB);
        const repositoryTimeslots = computed(() => wayToGetLocal.value === EWayToGet.OFFICE ? ERepositoryTimeslots.APPOINTMENTS : ERepositoryTimeslots.MB);

        const status = ref(EValidationStatus.IDDLE);
        watch(status, (val) => {
            emit('status', val);
        }, { immediate: true });

        const {
            data: cities,
            pending: isLoadingCities,
            valueObject: cityObject,
            productId,
        } = useBankCityList(
            regionLocal, props.productCode, repositoryCities, cityLocal,
            { immediate: true, disabled: () => wayToGetLocal.value === EWayToGet.DELIVERY && !regionLocal.value });

        watch(cityObject, (val) => {
            emit('city-title', val?.title);
            if (wayToGetLocal.value === EWayToGet.OFFICE && val) regionLocal.value = val.raw.attributes.region.code;
        }, { immediate: true });

        const {
            data: offices,
            pending: isLoadingOffices,
            valueObject: officeObject,
            workDays,
        } = useBankOfficeList(
            cityLocal, props.productCode, officeLocal,
            { immediate: true, disabled: () => wayToGetLocal.value === EWayToGet.DELIVERY || !cityLocal.value });

        watch(workDays, (val) => {
            emit('workDays', val);
        });

        const isEnabledDate = computed(() =>
            !props.noDateTime
            && ((wayToGetLocal.value === EWayToGet.DELIVERY && props.mbOnly) ? cityObject.value?.raw.isMbActive : true)
        );
        const isShowDate = computed(() =>
            isEnabledDate.value
            && !!cityLocal.value
            && ((wayToGetLocal.value === EWayToGet.OFFICE && !!officeLocal.value) || (wayToGetLocal.value === EWayToGet.DELIVERY && !!addressLocal.value))
        );

        const {
            data: times,
            pending: isLoadingTimes,
            valueObject: timeObject,
            execute: refreshTimes,
            checkIsDisabledDay: disabledDates,
            noAvailableDays,
        } = useBankTimeslotsList(
            cityLocal, officeLocal, productId, dateLocal, () => officeObject.value?.raw, repositoryTimeslots, timeLocal,
            { immediate: true, disabled: () => !isEnabledDate.value });

        const deliveryType = computed(() => {
            const typeIfOffice = EAppointmentDeliveryType.OFFICE;
            const typeBySelectedCity = cityObject.value?.raw.isMbActive ? EAppointmentDeliveryType.MB : EAppointmentDeliveryType.COURIER;
            const typeIfDelivery = timeObject.value?.slotType ?? typeBySelectedCity;
            return wayToGetLocal.value === EWayToGet.OFFICE ? typeIfOffice : typeIfDelivery;
        });

        watch(deliveryType, (val) => {
            emit('delivery-type', val);
        }, { immediate: true });

        const isEnabledAddress = computed(() => !props.noAddress && wayToGetLocal.value === EWayToGet.DELIVERY);
        const isShowAddress = computed(() => isEnabledAddress.value && cityLocal.value && !(isEnabledDate.value && noAvailableDays.value));

        watch([times, dateLocal], ([times, date]) => {
            if (times.length === 0 || !date || timeLocal.value && times.some((t) => timeLocal.value === t.const)) return;

            timeLocal.value = times[0].const ?? '';
        });

        watch(wayToGetLocal, () => {
            regionLocal.value = undefined;
        });

        watch(regionLocal, () => {
            if (wayToGetLocal.value === EWayToGet.DELIVERY) cityLocal.value = undefined;
        });

        watch(isEnabledAddress, (val) => {
            if (!val) addressLocal.value = undefined;
        });

        watch(cityLocal, () => {
            officeLocal.value = undefined;
            addressLocal.value = undefined;
            dateLocal.value = undefined;
        });

        watch(dateLocal, () => {
            timeLocal.value = undefined;
        });

        const addressLocations = computed(() => {
            let location;

            if (regionLocal.value) {
                location = {
                    kladr_id: regionLocal.value
                    //settlement: cityLocal.value,
                };
            }

            return location ? [location] : undefined;
        });

        const isShowCity = computed(() => (isLoadingCities.value || cities.value.length > 0) && (wayToGetLocal.value === EWayToGet.OFFICE || !!regionLocal.value));

        watch([isShowCity, wayToGetLocal], () => {
            cityLocal.value = undefined;
        });

        const slots = useSlots();
        const slotsDrill = computed(() => {
            const slotsDrill = { ...slots };
            const slotsDefinedInTemplate = ['noCitiesDeliveryNotice', 'noCitiesOfficeNotice'];
            slotsDefinedInTemplate.forEach((name) => {
                delete slotsDrill[name];
            });
            return slotsDrill;
        });

        watch([officeObject, cityObject], ([office, city]) => {
            emit('office-address', [city?.title, office?.raw.attributes.location.street, office?.raw.attributes.location.house].filter((item) => !!item).join(', '));
        });

        const isShowOffices = computed(() => {
            return wayToGetLocal.value === EWayToGet.OFFICE && cityLocal.value && (isLoadingOffices.value || offices.value.length > 0);
        });

        return {
            offices,
            isLoadingOffices,
            officeObject,
            cities,
            isLoadingCities,
            cityObject,
            wayToGetLocal,
            productId,
            times,
            timeObject,
            refreshTimes,
            isLoadingTimes,
            disabledDates,
            EWayToGet,
            regionLocal,
            cityLocal,
            officeLocal,
            addressLocal,
            dateLocal,
            timeLocal,
            addressLocations,
            status,
            ESuggestionTypes,
            unavailableOffice,
            unavailableOfficePending,
            isShowDate,
            isEnabledDate,
            isShowAddress,
            noAvailableDays,
            isShowCity,
            slotsDrill,
            isShowOffices,
            citiesError,
            slotsError
        };
    },
    validations() {
        return {
            regionLocal: {
                required: this.wayToGetLocal === EWayToGet.DELIVERY ? required : () => true,
                citiesNotFound: (val) => this.citiesError !== 500 ? this.wayToGetLocal === EWayToGet.OFFICE || !helpers.req(val) || this.isLoadingCities || this.cities.length > 0 : () => true,
                serviceError: this.citiesError === 500 && this.wayToGetLocal !== EWayToGet.OFFICE ? () => false : () => true
            },
            cityLocal: {
                required,
                officesNotFound: this.wayToGetLocal === EWayToGet.OFFICE ? (val) => !helpers.req(val) || this.isLoadingOffices || this.offices.length > 0 : () => true,
                noAvailableDays: (val) => this.slotsError !== 500 ? !helpers.req(val) || this.isLoadingTimes || !this.noAvailableDays || !this.isEnabledDate : () => true,
                serviceError: this.slotsError === 500 && this.wayToGetLocal !== EWayToGet.OFFICE ? () => false : () => true
            },
            officeLocal: {
                required: this.wayToGetLocal === EWayToGet.OFFICE ? required : () => true,
            },
            addressLocal: {
                requiredAddress: this.wayToGetLocal === EWayToGet.DELIVERY ? required : () => {return true},
                limitLatSymbol: this.wayToGetLocal === EWayToGet.DELIVERY ? limitLatSymbol(3) : () => {return true},
                maxLength: this.wayToGetLocal === EWayToGet.DELIVERY ? maxLength(255) : () => {return true}
            },
            dateLocal: {
                required: requiredIf(() => this.isShowDate),
                timesNotFound: (val) => !helpers.req(val) || this.isLoadingTimes || this.times.length > 0,
            },
            timeLocal: {
                required: requiredIf(() => this.isShowDate),
            },
        };
    },
    computed: {
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
        },
    },
    watch: {
        '$v.$invalid': {
            handler(val) {
                this.status = val ? EValidationStatus.INVALID : EValidationStatus.VALID;
            },
            immediate: true,
        },
        wayToGetLocal() {
            this.$v.$reset();
        },
    },
    methods: {
        validate() {
            this.$v.$touch();
        },
    },
};
</script>
